<template>
    <div class="juhR-name clearfix">

        <div class="juh-name">{{orgInfo.Name}}</div>

        <ul class="juhR-name-ul clearfix">

            <li v-if="orgInfo.Address"><em>地址：</em><p>{{orgInfo.Address}}</p></li>
            <li v-if="orgInfo.PostCode"><em>邮编：</em><p>{{orgInfo.PostCode}}</p></li>
            <li v-if="orgInfo.Phone"><em>电话：</em><p>{{orgInfo.Phone}}</p></li>
            <li v-if="orgInfo.Fax"><em>传真：</em><p>{{orgInfo.Fax}}</p></li>
            <li v-if="orgInfo.Email"><em>邮箱：</em><p><a :href="'mailto:'+orgInfo.Email">{{orgInfo.Email}}</a></p></li>
            <li v-if="orgInfo.WebUrl"><em>网址：</em><p><a :href="urlFun(orgInfo.WebUrl)" target="_blank">{{orgInfo.WebUrl}}</a></p></li>
            <li v-if="orgInfo.MiroblogPic" class="reaCode">
                <em id="qrCodeEm">微信公众号：</em>
                <p id="qrCodeP" 
                   @mousemove="mouseOver"
                   @mouseleave="mouseLeave"
                >
                    移入查看二维码
                </p>
                <div class="qrCodeDiv"  v-show="isQRCode" >
                    <img class="codeImg" :src="orgInfo.MiroblogPic">
                    <div>打开微信【扫一扫】</div>
                    <div>扫描二维码</div>
                </div>    
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "OrgInfo",
    props:['orgInfo'],
    data() {
        return {
            isQRCode: false
        }
    },
    methods: {
        urlFun(e){
            if(e.indexOf('http') != -1 || e.indexOf('https') != -1){
                return e
            }else{
                return '//'+e 
            }
        },
        mouseOver() {
            this.isQRCode = true;
        },
        mouseLeave() {
            this.isQRCode = false;
        }
    }
}
</script>

<style scoped lang="scss">
.juhR-name {
    border: #e6e6e6 1px solid;
    margin-top: 10px;
    padding-bottom: 20px;
    font-size: 12px;
    color:#000;
    font-family: SimSun;
}
.juh-name, .right-tit {
    height: 35px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    line-height: 35px;
    border-bottom: #468ad1 1px solid;
}
.juh-name{text-align: center;}
.juhR-name-ul {
    line-height: 24px;
    padding: 14px 0px 14px 19px;
    color: #333333;
}
.juhR-name-ul em {
    width: 36px;
    float:left;
}
.juhR-name-ul p {
    width: 215px;
    float:left;
}
#qrCodeEm {
    width: 73px;
}
#qrCodeP {
    width: 150px;
    cursor: pointer;
    &:hover {
        color: #5bb2e4;
    }
}
.reaCode {
    position: relative;
    .qrCodeDiv {
    position: absolute;
    top: 200px;
    text-align: center;
    width: 150px;
    height: 192px;
    color: rgba(102, 102, 102, 1);
    background-color: #fff;
    /* opacity: 0; */
    .codeImg {
        width: 130px;
        height: 130px;
    }
}
}

</style>